import * as yup from 'yup';
import { TEXT_TO_WIN_TEMPLATE_VALUE_TYPES } from 'src/constants/templateValueTypes';
import {
  createDefaultTextToWinSettings,
  normalizeTextToWinSettings,
} from 'src/modules/campaigns/helpers';
import { CampaignFormValues, CampaignPayloadParams } from '../../types';
import {
  buildTextToWinPayloadFields,
  getTextToWinMessageTexts,
  validateTextToWinSettings,
} from '../../helpers/textToWinSettingsHelpers';
import { commonDefaults } from '../shared/campaignDefaults';
import { hasMissingRequiredKeywords } from '../shared/primaryActionChecks';
import { commonSchemaShape } from '../shared/validationSchema';
import { CampaignTypeSpec } from '../policy';
import { policyIssue } from '../issues';
import { textToWinSettingsFromTemplate } from 'src/modules/campaignConfigBuilder/helpers/templatePrefill';
import { hasErrors, standardFields } from './shared';

export const textToWinSpec: CampaignTypeSpec = {
  externalType: 'custom',
  placeholderFamilies: TEXT_TO_WIN_TEMPLATE_VALUE_TYPES,
  blocklistTexts: values =>
    getTextToWinMessageTexts(normalizeTextToWinSettings(values.textToWinSettings)),
  fields: config => standardFields(config, ['textToWinWinners', 'textToWinSettings']),

  defaults: config => ({
    ...commonDefaults(config),
    scheduledMessages: [],
    textToWinSettings: textToWinSettingsFromTemplate(config.textToWinSettings)
      ?? createDefaultTextToWinSettings(),
  }),

  fromCampaign: (base, campaign) => ({
    ...base,
    scheduledMessages: [],
    textToWinSettings: normalizeTextToWinSettings(campaign.campaignTextToWinSettings),
  }),

  issues: (values, config) => policyIssue(
    !values.name
    || hasErrors(validateTextToWinSettings(normalizeTextToWinSettings(values.textToWinSettings)))
    || hasMissingRequiredKeywords(values, config),
    'text-to-win-primary-blocked',
  ),

  payload: ({ base, values }) => {
    const payload: CampaignPayloadParams = {
      ...base,
      keywords: values.keywordIds ?? [],
      ...buildTextToWinPayloadFields(normalizeTextToWinSettings(values.textToWinSettings)),
    };
    delete (payload as Partial<CampaignPayloadParams>).scheduledMessages;
    return payload;
  },

  schema: config => yup
    .object(commonSchemaShape(config, { keywords: true }))
    .test('text-to-win-settings', 'Prize draw settings are incomplete', function (values) {
      const errors = validateTextToWinSettings(
        normalizeTextToWinSettings((values as CampaignFormValues).textToWinSettings),
      );
      if (!hasErrors(errors)) return true;
      return this.createError({ message: Object.values(errors)[0] });
    }),
};
